import { createAction } from 'redux-actions';
import { reduxKey } from '../constants';
export var attemptSocialLogin = createAction("".concat(reduxKey, ".ATTEMPT_SOCIAL_LOGIN"), function (params) { return params; });
export var initializeFacebookJSSDK = createAction("".concat(reduxKey, ".FACEBOOK.INIT"), function () { return ({}); });
export var setSocialLoginError = createAction("".concat(reduxKey, ".SET_ERROR"), function (errorCode) { return ({
    errorCode: errorCode,
}); });
// Callback actions
export var socialLoginSuccess = createAction("".concat(reduxKey, ".LOGIN_SUCCESS"), function (params) { return params; });
//# sourceMappingURL=actions.js.map